import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import MethodContent from './components/MethodContent'

function Method() {
  useEffect(() => {
    document.title = 'Dorac - Nosso Método'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <MethodContent />
      <Footer />
    </main>
  )
}

export default Method
